async function onSwymLoadCallback(swat) {
    let current = 0;
    const container = document.querySelector('[data-handle="wishlist-container"]');
    const itemsContainer = document.querySelector('.plp__list[data-items-container]');
    const placeholderContainer = document.querySelector('.plp__list[data-placeholder-container]');

	
	const primaryLang = document.body.dataset.primaryLang;
	function getLocalizedProductUrl(url) {
		if (primaryLang == 'true') {
			//console.log('returning base url');
			return url;
		}

		const parsedUrl = new URL(url);
		const host = parsedUrl.origin;
		const locale = Shopify.locale;
		const path = parsedUrl.pathname;
		const newURL = `${host}/${locale}${path}`;
		//console.log(newURL);
		return newURL;
	}

    const removeProductFromList = (lid, products) => {
        return new Promise((resolve, reject) => {
            swat.removeProductsFromList(
                lid,
                products,
                (removedProducts) => {
					const gaData = {
						//sku: sku,
						//type: type,
						//source: source,
						empi: `${removedProducts[0].empi}`,
						dt: removedProducts[0].dt,
						pr: removedProducts[0].pr,
					}
					//console.log('Removed: ', gaData);
					window.ga4_update_wishlist(gaData, 'remove')
					resolve(removedProducts)
				},
                (error) => reject(error)
            )
        });
    }

    function fetchListCtx(wishlistLid) {
        return new Promise((resolve, reject) => {
            swat.fetchListCtx(
                { "lid": wishlistLid },
                function(listContents) {
                    resolve(listContents);
                },
                function(onError) {
                    console.log("Error fetching List contents", onError);
                }
            )
        })
    };

    function fetchList() {
        return new Promise((resolve, reject) => {
            swat.fetchLists({
                callbackFn: function (lists) {
                    resolve(lists);
                },
                errorFn: function(error) {
                    resolve([]);
                    console.log("Error while fetching all Lists", error);
                }
            });
        });
    }

    function createList() {
        return new Promise((resolve, reject) => {
            swat.createList(
                { "lname": "My Wishlist" },
                function(newList) {
                    resolve(newList);
                },
                function(error) {
                    console.log("Error while creating a List", error);
                }
            )
        })
    }

    const lists = await fetchList();
    if(lists.length) {
        const listContents = await fetchListCtx(lists[0].lid);
        init(lists[0].lid, listContents)
    } else {
        const list = await createList();
    }

    async function init(wishlistLid, listContents) {
		// New array of items, all variants grouped into parent products instead of individual variant objects (returned by the wishlist)
		//console.log('Full list: ', listContents);
        const items = [...listContents.reduce((acc, item) => {
			// in the new array, check if the group.id matches item product id
            const existingGroup = acc.find(group => group.id === item.empi);
			// if so is a product level item
            if(existingGroup) {
              existingGroup.variant_ids.push(item.epi);
			  existingGroup.sku = item.sku.slice(0,11);//replace variant sku with product level sku
            } else {
              acc.push({
                id: item.empi,
                title: item.dt,
                price: item.pr,
                url: item.du,
                variant_ids: [item.epi],
				sku: item.sku,
              })
            }
        
            return acc;
        }, [])];


        if(!items.length) {
            // document.querySelector('.swym-wishlist-page__info-count').style.display = 'block';
            // document.querySelector('.swym-wishlist-filter').style.display = 'none';
            placeholderContainer.style.display = 'none';
        }


        const removeProductFromWishlist = (el, wishlistLid) => {
            el.addEventListener('click', async function() {
                const productItem = this.closest('.product-item');
                const empi = Number(this.dataset.wishlistEmpi);
                const du = `${window.location.origin}/products/${this.dataset.wishlistHandle}`;

                const data = listContents.filter(item => item.empi === empi)
                    .map(item => item.epi)
                    .map(epi => ({
                        empi,
                        epi,
                        du
                    }));

                const batchSize = 10;
                const promises = [];

                for(let i = 0; i < data.length; i += batchSize) {
                    const batch = data.slice(i, i + batchSize);

                    promises.push(removeProductFromList(wishlistLid, batch))
                }

                Promise.all(promises).then(data => {

                    if(productItem.parentNode) {
                        productItem.parentNode.removeChild(productItem);
                    }

                    const index = items.findIndex(item => item.id === empi);

                    if(index !== -1){
                        items.splice(index, 1);
                    }

                    if(!document.querySelectorAll('.product-item').length) {
                        document.querySelector('.swym-wishlist-page__info-count').style.display = 'block';
                        document.querySelector('.swym-wishlist-filter').style.display =  'none';
                    } else {
                        document.querySelector('.swym-wishlist-filter').style.display = 'block';
                    }
                });

            })
        }

        function handleIntersection(entries) {
            entries.forEach(entry => {
              if(entry.isIntersecting) {
                intersectionObserver.unobserve(entry.target);
                wishlistPageRenderItems(items);
              }
            });
        }

        const initIntersectionObserver = () => {
            const productItems = Array.from(document.querySelectorAll('.product-item'));
            const totalProducts = productItems.length;
            const intersectionTrigger = productItems[Math.ceil(totalProducts / 2)];
        
            if(!intersectionTrigger) {
                return;
            }
              
            intersectionObserver = new IntersectionObserver(handleIntersection);
            intersectionObserver.observe(intersectionTrigger);
        }

        const wishlistPageRenderItems = async () => {
            if(current > items.length) {
              return;
            }
          
            placeholderContainer.style.display = 'flex';
          
            const batch = items.slice(current, current + 20);
            current = current + 20;
          
            const productHtml = await Promise.all(
              batch.map(async (product) => {
                return new Promise((resolve, reject) => {
					//console.log(product);
                  const productUrl = product.url.split('?')[0];
				  const localizedURL = getLocalizedProductUrl(productUrl);
				  //console.log(localizedURL);
                  fetch(`${localizedURL}?view=wishlist-product-item&variantids=${product.variant_ids.join(',')}`)
                    .then(async response => {
                      if(response.status !== 200) {
                        const data = product.variant_ids
                          .map(vid => ({
                            empi: product.id,
                            epi: vid,
                            du: product.url,
                          }))
                        const batchSize = 5;
                        const promises = [];
          
                        for(let i = 0; i < data.length; i += batchSize) {
                            const batch = data.slice(i, i + batchSize);

                            promises.push(
                                removeProductFromList(wishlistLid, batch)
                            )
                        }
                        await Promise.all(promises);
          
                        resolve(undefined);
                      }
          
                      return response.text();
                    })
                    .then(html => {
                      resolve(html);
                    })
                })
              })
            );

            const documentFragment = document.createDocumentFragment();
            const range = document.createRange();

            for(let i = 0; i < productHtml.length; i++) {
                const productNode = range.createContextualFragment(productHtml[i]); // Create a DocumentFragment from HTML string
                if(!productNode) { return; }
                documentFragment.appendChild(productNode);
            }
          
            window.productItem($(documentFragment));
            itemsContainer.appendChild(documentFragment);
            placeholderContainer.style.display = 'none';

            document.querySelectorAll('.swym-wishlist-remove-item').forEach(el => removeProductFromWishlist(el, wishlistLid));
            initIntersectionObserver();

			window.ga4_wishlist_view_list();
        }     

        if(!listContents.length) {
            document.querySelector('.swym-wishlist-page__info-count').style.display = 'block';
            document.querySelector('.swym-wishlist-filter').style.display = 'none';
            placeholderContainer.style.display = 'none';
        } else {
            document.querySelector('.swym-wishlist-filter').style.display = 'block';
        }

        await wishlistPageRenderItems();

        document.querySelector('[data-handle="wishlist-sort-by"]').addEventListener('click', function(e) {
            const optionsContainerEl = this.querySelector('.sort-dropdown__content');
            optionsContainerEl.classList.toggle('hidden');
        })

        document.querySelectorAll('[data-sort-val]').forEach(function(el) {
            el.addEventListener('click', async function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const val = this.getAttribute('data-sort-val');
                if(val === 'featured') {
                    current = 0;
                    while (itemsContainer.firstChild) {
                        itemsContainer.firstChild.remove();
                    }
                    await wishlistPageRenderItems(items);
                } else {
                    current = 0;
                    const sortedItems = items.sort((a, b) => {
                        if(val === 'asc') {
                            return a.price - b.price;
                        } else if(val === 'desc') {
                            return b.price - a.price
                        }
                    });

                    while(itemsContainer.firstChild) {
                        itemsContainer.firstChild.remove();
                    }

                    await wishlistPageRenderItems(sortedItems);
                }
            })
        });
    }

}

if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback)